// extracted by mini-css-extract-plugin
module.exports = {"container":"contact_container__2W6A_","textConent":"contact_textConent__CqNGM","image":"contact_image__1v_-g","instaIcon":"contact_instaIcon__1_FHc"};